<template>
  <div id="trackingCodePopup"
       class="dimmed">
    <div class="popup__content">
      <h2 class="title">{{ $t('common.trackingCode.title') }}</h2>
<!--      <div class="update">-->
<!--        <div style="display: flex; align-items: center; column-gap: 8px;">-->
<!--          <i class="update__image" alt=""></i>-->
<!--          <span class="update__info" v-html="updateText"></span>-->
<!--        </div>-->
<!--        <div style="display: flex; align-items: center; column-gap: 5px;">-->
<!--          <a class="update__more" :href="newCodeInfoLink" target="_blank">{{ $t('common.trackingCode.update.more') }}</a>-->
<!--          <a class="update__contact" href="https://www.beusable.net/contact" target="_blank">{{ $t('common.trackingCode.update.contact') }}</a>-->
<!--        </div>-->
<!--      </div>-->
      <p class="desc" v-html="$t('common.trackingCode.desc')"></p>
      <div class="content">
        <div class="content__line">
          <span>1</span>
          <span>2</span>
          <span>3</span>
          <span>4</span>
          <span>5</span>
          <span>6</span>
          <span>7</span>
          <span>8</span>
          <span>9</span>
          <span>10</span>
          <span>11</span>
        </div>
        <div class="content__code">
          <pre>{{ trackingCode }}</pre>
        </div>
        <div class="content__toast" v-if="showToastLayer">
          <span>{{ $t('common.trackingCode.copied') }}</span>
          <i class="icon icon--check-green-size16"></i>
        </div>
      </div>
      <div class="btn__copy">
        <button class="button" @click="copyCode">
          {{ $t('common.copy') }}
        </button>
        <slot name="somethingAction" />
      </div>
      <button class="btn__close" @click="$emit('closePopup')">
        <i class="icon icon--close-btn"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { getCode } from '@/api/apply'
import { NEW_CODE_DEPLOY_DATE, NEW_CODE_INFO_LINK } from '@/libs/constants'
import { getUserInfo } from '../../api/user'

export default {
  name: 'trackingCode',
  props: [
    'sid'
  ],
  data () {
    return {
      trackingCode: '',
      showToastLayer: false,
      updateText: '',
      newCodeInfoLink: NEW_CODE_INFO_LINK
    }
  },
  methods: {
    copyCode () {
      let range = document.createRange()
      range.setStartBefore(document.querySelector('pre'))
      range.setEndAfter(document.querySelector('pre'))
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      document.execCommand('copy')
      this.showToastLayer = true
      setTimeout(() => {
        this.showToastLayer = false
      }, 5000)
    }
  },
  created () {
    getCode(this.sid).then(data => {
      this.trackingCode = data
    })

    getUserInfo().then((result) => {
      this.updateText = this.$t('common.trackingCode.update.info.new')
      if (result.regDate && result.regDate < NEW_CODE_DEPLOY_DATE) {
        this.updateText = this.$t('common.trackingCode.update.info.old')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  #trackingCodePopup {
    .popup__content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 640px;
      border-radius: 14px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background-color: #ffffff;
      padding-top: 30px;
      padding-bottom: 12px;
      padding-left: 30px;
      padding-right: 30px;
      box-sizing: border-box;
      overflow: hidden;

      .title {
        font-size: 15px;
        font-weight: 600;
        color: #2f2f2f;
      }

      .update {
        position: relative;
        left: -30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        box-sizing: border-box;
        width: 640px;
        height: 54px;
        margin-top: 20px;
        padding: 14px 15px;

        background-color: #f4e439;

        &__image {
          display: inline-block;
          width: 20px;
          height: 20px;

          background-image: url(../../assets/img/icon-trackingcode-new.svg);
        }

        &__info {
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.46;
          letter-spacing: normal;
          color: #2f2f2f;
        }

        &__more {
          padding: 4px 12px;
          border-radius: 5px;
          background-color: #fff;

          font-size: 13px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.46;
          letter-spacing: normal;
          text-align: center;
          color: #ec0047
        }

        &__contact {
          border-radius: 5px;
          background-color: #fff;
          padding: 4px 12px;

          font-size: 13px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.46;
          letter-spacing: normal;
          text-align: center;
          color: #444;
        }
      }

      .desc {
        font-size: 12px;
        color: $brandColor;
        margin-top: 25px;
        font-weight: 500;
      }

      .content {
        position: relative;
        margin: 10px auto 12px;
        width: 580px;
        height: 240px;
        overflow-y: auto;
        border-radius: 5px;
        border: solid 1px #d7d7d7;
        background-color: #f4f4f4;

        .content__line {
          width: 32px;
          position:absolute;
          top:0;
          bottom:0;
          left:0;
          background-color: #fff;
          border-radius: 4px;
          padding-top: 10px;
          padding-bottom: 10px;
          box-sizing: border-box;

          span {
            display:block;
            text-align:center;
            font-size: 13px;
            line-height: 1.54;
            color: #444444;
          }
        }
        .content__code {
          position:absolute;
          width:547px;
          top:0;
          bottom:0;
          right:0;
          box-sizing: border-box;
          padding-top: 10px;
          padding-bottom: 10px;
          padding-left: 12px;
          font-size: 13px;
          line-height: 1.54;
          color: #444444;
        }
        .content__toast {
          display: inline-block;
          height: 32px;
          border-radius: 6px;
          box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
          background-color: rgba(0,0,0,0.85);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          padding-left: 12px;
          padding-right: 45px;
          span {
            font-size: 13px;
            font-weight: 600;
            color: #57ab00;
            line-height: 32px;
          }
          i {
            position: absolute;
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
          }
        }
      }
      .btn__copy {
        text-align: center;
        button {
          @include buttonTypeNormal;
          border: solid 1px #bbbbbb;
          font-size: 14px;
          font-weight: 600;
          color: #444;

          &:hover {
            @include hoverStyle;
          }
        }
      }
      .btn__close {
        padding: 15px;
        position: absolute;
        top: 0;
        right: 0;
        i {
          pointer-events: none;
          background-position: center;
        }
      }
    }
  }
</style>
